import { Action } from './type'

export type ContactPersonsAction = Action & {
  type: 'SUCCESS_FETCH_CONTACT_PERSONS'
}

export type ContactPersonsResponse = {
  users: {
    id: number
    firstName: string
    lastName: string
  }[]
}

export const FETCH_CONTACT_PERSONS = 'FETCH_CONTACT_PERSONS'
export function fetchContactPersons() {
  return { type: FETCH_CONTACT_PERSONS }
}

export const SUCCESS_FETCH_CONTACT_PERSONS = 'SUCCESS_FETCH_CONTACT_PERSONS'
export function successFetchContactPersons(
  contactPersons: ContactPersonsResponse
) {
  return { type: SUCCESS_FETCH_CONTACT_PERSONS, payload: contactPersons }
}

export const FAILED_FETCH_CONTACT_PERSONS = 'FAILED_FETCH_CONTACT_PERSONS'
export function failedFetchContactPersons(message: string) {
  console.log('Error:  FAILURE_FETCH_CONTACT_PERSONS', message)
  return { type: FAILED_FETCH_CONTACT_PERSONS }
}

export const contactPersonsActions = {
  fetchContactPersons,
  successFetchContactPersons,
  failedFetchContactPersons,
}
